import { rgba } from 'polished';
import styled from 'styled-components';
import { TagStatus } from './enums';
import { TagProps } from './types';

const tagColor = (
  theme: { colors: { tag: Record<string, { background: string }> } },
  status: TagStatus,
  color?: string
) => color || theme.colors.tag[status].background;

export const StyledTag = styled.div<TagProps>`
  display: inline-flex;
  align-items: center;
  gap: 0.375rem;
  padding: 0.1875rem 0.5rem;
  border-radius: 999px;
  background-color: ${({ theme, status = TagStatus.Success, color }) =>
    rgba(tagColor(theme, status, color), 0.14)};
  border: 1px solid
    ${({ theme, status = TagStatus.Success, color }) =>
      rgba(tagColor(theme, status, color), 0.32)};
  color: ${({ theme, status = TagStatus.Success, color }) =>
    tagColor(theme, status, color)};
  font-size: 0.75rem;
  font-weight: 500;
  letter-spacing: -0.005em;
  line-height: 1.25;
  white-space: nowrap;

  &::before {
    content: '';
    width: 0.4375rem;
    height: 0.4375rem;
    background: ${({ theme, status = TagStatus.Success, color }) =>
      tagColor(theme, status, color)};
    border-radius: 100%;
    flex-shrink: 0;
  }

  span {
    color: inherit;
  }
`;
